import React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import ContentWrapper from "../../../components/Container/ContentWrapper"
import SectionCategory from "../../../components/Typography/SectionCategory"
import SectionTitle from "../../../components/Typography/SectionTitle"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"
import SectionDescription from "../../../components/Typography/SectionDescription"
import retention from "../../../assets/images/analytics/retention.png"
import retentionEn from "../../../assets/images/analytics/retention_en.png"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "48px 20px",
      background: "#FFF",
      [theme.breakpoints.up("md")]: {
        padding: "100px 0",
      },
    },
    wrapper: {
      marginTop: 65,
      boxSizing: "border-box",
      width: "100%",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        marginTop: 38,
        fontSize: 0,
      },
    },
  })
)
export default function Retention() {
  const classes = useStyles()
  const { isDesktop } = usePlatform()
  const { lang } = Locale.getDefault()
  const { ref } = useScrollImpressionLog({
    message: "3_0: 잔존율, 이탈률, 재사용률 등의 지표로 제품 성과를 확인해 보세요.",
    eventKey: "homepage_data_analytics_detail_section_3_impression",
  })

  return (
    <div className={classes.root} ref={ref}>
      <ContentWrapper>
        <SectionCategory>Retention</SectionCategory>
        <SectionTitleByLang lang={lang} isDesktop={isDesktop} />
        <SectionDescriptionByLang lang={lang} isDesktop={isDesktop} />
        <div className={classes.wrapper}>{lang === "ko" ? <img src={retention} /> : <img src={retentionEn} />}</div>
      </ContentWrapper>
    </div>
  )
}

interface LangProps {
  lang: string
  isDesktop: boolean
}
function SectionTitleByLang({ lang, isDesktop }: LangProps) {
  if (lang === "ko")
    return (
      <SectionTitle>
        잔존율, 이탈률, 재사용률 등의 지표로 {isDesktop && <br />}
        제품 성과를 확인해 보세요.
      </SectionTitle>
    )

  return (
    <SectionTitle>
      Check the results of your product performance {isDesktop && <br />}by retention rate, churn rate, reuse rate, etc.
    </SectionTitle>
  )
}

function SectionDescriptionByLang({ lang, isDesktop }: LangProps) {
  if (lang === "ko")
    return (
      <SectionDescription>
        리텐션은 제품의 성공 지표 그 자체입니다. <br />
        다양한 조건으로 사용자의 재사용 패턴을 깊이 있게 파악해 보세요.
      </SectionDescription>
    )

  return (
    <SectionDescription>
      Retention is a product success indicator itself. {isDesktop && <br />}
      Gain deep insights into user's stickiness under various conditions.
    </SectionDescription>
  )
}
